import React from "react";
import { createPortal } from "react-dom";

import Tooltip from "components/Tooltip";

const ModelHeaderTooltips = ({ showSyncTip }) =>
    createPortal(
        <>
            <Tooltip id="modelNameTip" />
            <Tooltip id="insightsTagTip" />
            <Tooltip id="reviewProgressTip" />
            <Tooltip id="saveTip" />
            {showSyncTip && <Tooltip id="syncTip" hide={showSyncTip} />}
            <Tooltip id="drawingTip" delay />
            <Tooltip id="openToggleTip" />
            <Tooltip id="photoGalleryTip" />
            <Tooltip id="unitsTip" />
        </>,
        document.body
    );

export default ModelHeaderTooltips;
